import axios from "axios";
import appConfig from "../config/app.config";
import { setUser } from "../libs/user";

const loggedInExchangeRate = (token) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "post",
      url: `${appConfig.apiUrl.exchangeRate}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then((response) => {
        const {
          exchange_rates,
          promotional_exchange_rate_applicable,
          promo_condition,
        } = response.data || {};
        const {
          current_exchange_rate,
          effective_exchange_rate,
          display_effective_exchange_rate,
          display_current_exchange_rate,
          exchange_rate_currency
        } = exchange_rates || {};
        resolve({
          display_base_fx: display_current_exchange_rate,
          display_promo_fx: display_effective_exchange_rate,
          base_fx: current_exchange_rate,
          promo_fx: effective_exchange_rate,
          is_promo_applicable: promotional_exchange_rate_applicable,
          promo_condition: promo_condition,
          exchange_rate_currency: exchange_rate_currency
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const nonLoggedInExchangeRate = () => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      url: `${appConfig.apiUrl.getExchangeRate}?source_currency=USD&destination_currency=INR`,
    };
    axios(config)
      .then((response) => {
        const {
          promotional_exchange_rate_applicable,
          formatted_base_fx_rate,
          formatted_promo_fx_rate,
          promo_fx_rate,
          base_fx_rate,
          promo_condition,
        } = response.data || {};
        resolve({
          displayBaseFx: formatted_base_fx_rate,
          display_promo_fx: formatted_promo_fx_rate,
          base_fx: base_fx_rate,
          promo_fx: promo_fx_rate,
          is_promo_applicable: promotional_exchange_rate_applicable,
          promo_condition: promo_condition,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const cricbuzzSendOtpService = (obj) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "post",
      url: appConfig.apiUrl.cricbuzzSendOtp,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
      },
      data: obj,
    };

    axios(config)
      .then((response) => {
        setUser(response.data)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const cricbuzzVerifyOtpService = (verifyOtpData) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "post",
      url: appConfig.apiUrl.cricbuzzVerifyOtp,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
      },
      data: verifyOtpData,
    };

    axios(config)
      .then((response) => {
        setUser(response.data)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const cricbuzzResendOtpService = (resendOtpData) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "post",
      url: appConfig.apiUrl.cricbuzzResendOtp,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
      },
      data: resendOtpData,
    };

    axios(config)
      .then((response) => {
        setUser(response.data)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const cricbuzzResendMsgService = (resendMsgData) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "post",
      url: appConfig.apiUrl.cricbuzzResendMsg,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
      },
      data: resendMsgData,
    };

    axios(config)
      .then((response) => {
        setUser(response.data)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export {
  loggedInExchangeRate,
  cricbuzzSendOtpService,
  cricbuzzVerifyOtpService,
  cricbuzzResendOtpService,
  cricbuzzResendMsgService,
  nonLoggedInExchangeRate,
};
